import React from 'react'
import Card from '../components/Card'

const Documentation = () => {
    let kariAsync: string = `Handles asynchronous task execution, 
    allowing you to schedule and run tasks at specific intervals without blocking your program.`;
    let kariPulse = `Simplifies the process of toggling or managing the state of multiple pins in unison`;
    let kariSequential = `Enables sequential operation of pins, useful for tasks like animating LEDs or managing stepper motors.`;
    let kariUltrasonic = `A utility for integrating ultrasonic sensors, enabling precise distance measurement.`;
    let kariPIR = 'Manages Passive Infrared (PIR) motion sensors for detecting movement.';
    let kariInfrared = `A utility class which provides a simple interface for working with infrared (IR) sensors in the Kari IoT Library.`
    let kariBegin = `A special function used for initialing pins thus simplifying pins initialization`;
    let utility = `The library offers powerful templates for tasks like:
    Accessing class properties using getProperty or getPropertyPtr.
    Measuring distances or retrieving class-level data.`;
    return (
        <div>
            <Card intro="kariAsync" data ={kariAsync} class="card" page="kariAsync" route="/docs" text="Explore"/>
            <Card intro="kariPulse" data ={kariPulse} class="card" page="kariPulse" route="/docs" text="Explore"/>
            <Card intro="kariSequential" data ={kariSequential} class="card" page="kariSequential" route="/docs" text="Explore"/>
            <Card intro="kariUltrasonic" data ={kariUltrasonic} class="card" page="kariUltrasonic" route="/docs" text="Explore"/>
            <Card intro="kariPIR" data ={kariPIR} class="card" page="kariPIR" route="/docs" text="Explore"/>
            <Card intro="kariInfrared" data ={kariInfrared} class="card" page="kariInfrared" route="/docs" text="Explore"/>
            <Card intro="kariBegin" data={kariBegin} class="card" page="kariBegin" route="/docs" text="Explore"/>
            <Card intro="Utility Templates" data ={utility} class="card" page="kariUtility" route="/docs" text="Explore"/>
        </div>
    )
}

export default Documentation
